(() => {
  const init = (root) => {
    if (!root || root.dataset.ctInit === '1') return;
    root.dataset.ctInit = '1';
    const tabs = [...root.querySelectorAll('[data-ct-tab]')];
    const panels = [...root.querySelectorAll('[data-ct-panel]')];
    const activate = (name, focus = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.ctTab === name;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.ctPanel !== name; });
    };
    if (tabs.length) {
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.ctTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next].dataset.ctTab, true);
        });
      });
      activate(root.dataset.defaultTab || 'tracking');
    }

    const form = root.querySelector('[data-ct-form]');
    if (form) {
      const input = form.querySelector('[data-ct-input]');
      const error = form.querySelector('[data-ct-error]');
      const resultsShell = root.querySelector('[data-ct-results-shell]');
      const results = root.querySelector('[data-ct-results]');
      let loader = null;
      const showError = (message) => { error.textContent = message; error.hidden = !message; };
      const ensureSDK = () => {
        if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') return Promise.resolve();
        if (loader) return loader;
        loader = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://www.17track.net/externalcall.js';
          script.async = true;
          script.onload = () => {
            if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') resolve();
            else reject(new Error('17TRACK did not initialize.'));
          };
          script.onerror = () => reject(new Error('17TRACK is unavailable.'));
          document.head.appendChild(script);
        }).catch((err) => { loader = null; throw err; });
        return loader;
      };
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const trackingNumber = input.value.trim();
        showError('');
        if (!/^[A-Za-z0-9][A-Za-z0-9 \-]{4,49}$/.test(trackingNumber)) {
          showError('Please enter a valid tracking number (5–50 letters, numbers or hyphens).');
          input.focus();
          return;
        }
        const submit = form.querySelector('[type="submit"]');
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        try {
          await ensureSDK();
          if (!root.isConnected) return;
          resultsShell.hidden = false;
          results.replaceChildren();
          window.YQV5.trackSingle({
            YQ_ContainerId: results.id,
            YQ_Height: 560,
            YQ_Fc: '0',
            YQ_Lang: 'en',
            YQ_Num: trackingNumber
          });
          resultsShell.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        } catch (err) {
          showError('Tracking service could not load. Please try again or use the official 17TRACK website.');
        } finally {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        }
      });
    }

    const iframe = root.querySelector('[data-ct-iframe]');
    if (iframe) {
      const updateHeight = (event) => {
        if (!event.origin || !/^https:\/\/([\w-]+\.)*17track\.net$/i.test(event.origin)) return;
        if (event.source !== iframe.contentWindow) return;
        const data = event.data;
        if (!data || data.type !== 'resize' || !Number.isFinite(data.scrollHeight)) return;
        iframe.style.height = Math.min(3000, Math.max(550, data.scrollHeight)) + 'px';
      };
      window.addEventListener('message', updateHeight);
      root._ctCleanup = () => window.removeEventListener('message', updateHeight);
    }
  };
  const all = (scope = document) => scope.querySelectorAll('[data-coasta-track]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => all());
  else all();
  document.addEventListener('shopify:section:load', (event) => all(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-coasta-track]').forEach((root) => root._ctCleanup?.()));
})();
